import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2456bc25"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-align-center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, " 修改人： ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, " 修改前内容： ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title margin-top-5" }, " 修改后内容： ", -1))
const _hoisted_5 = { class: "flex flex-align-center margin-top-15" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "需求状态：", -1))
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "flex flex-align-center" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "审批编号：", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_ShowTable = _resolveComponent("ShowTable")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_timeline_item = _resolveComponent("el-timeline-item")!
  const _component_el_timeline = _resolveComponent("el-timeline")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    title: "操作日志",
    modelValue: _ctx.visible,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.visible) = $event)),
    "append-to-body": "",
    size: _ctx.type === 'PRODUCTION' ? 300 : 800
  }, {
    default: _withCtx(() => [
      _withDirectives(_createVNode(_component_el_empty, { description: "暂无数据" }, null, 512), [
        [_vShow, !_ctx.list?.length]
      ]),
      _createVNode(_component_el_timeline, { class: "logger-timeline" }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, i) => {
            return (_openBlock(), _createBlock(_component_el_timeline_item, {
              placement: "top",
              key: i,
              color: i === 0 ? '#409EFF' : '',
              timestamp: _ctx.$filters.formatTime(item.createdTime)
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _hoisted_2,
                  _createElementVNode("div", null, _toDisplayString(item.creatorName), 1)
                ]),
                _createElementVNode("div", null, [
                  _hoisted_3,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.diffList, (it, idx) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: idx,
                      class: "content"
                    }, [
                      _createElementVNode("p", null, _toDisplayString(_ctx.getLogItem(it, 'oldValue')), 1)
                    ]))
                  }), 128)),
                  (_ctx.type !== 'PRODUCTION' && item.showOrderDetail)
                    ? (_openBlock(), _createBlock(_component_ShowTable, {
                        key: 0,
                        data: item.originalLog.oldOrder.detailList
                      }, null, 8, ["data"]))
                    : _createCommentVNode("", true),
                  _hoisted_4,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.diffList, (it, idx) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: idx,
                      class: "content"
                    }, [
                      _createElementVNode("p", null, _toDisplayString(_ctx.getLogItem(it, 'newValue')), 1)
                    ]))
                  }), 128)),
                  (_ctx.type !== 'PRODUCTION' && item.showOrderDetail)
                    ? (_openBlock(), _createBlock(_component_ShowTable, {
                        key: 1,
                        data: item.originalLog.updateOrder.detailList
                      }, null, 8, ["data"]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  (_ctx.type === 'PRODUCTION')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.$filters.getEnumLabel(_ctx.PRODUCTION_DEMAND_STATUS_LIST, item?.originalLog?.targetProdDemand?.state ?? '')), 1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.$filters.getEnumLabel(_ctx.PRODUCTION_DEMAND_STATUS_LIST, item?.originalLog?.demandDetail?.state)), 1))
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("div", null, _toDisplayString(item?.originalLog?.serialNumber), 1)
                ]),
                _createVNode(_component_el_image, {
                  class: "image",
                  fit: "cover",
                  src: item?.originalLog?.images?.[0],
                  "preview-src-list": item?.originalLog?.images || []
                }, null, 8, ["src", "preview-src-list"])
              ]),
              _: 2
            }, 1032, ["color", "timestamp"]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue", "size"]))
}